import React from 'react';
import { ArrowRight } from 'lucide-react';
export const PriceDisplay = ({
  amount,
  className = ''
}: {
  amount: string;
  className?: string;
}) => {
  const symbol = '$';
  return <span className={className} data-id="element-336">
      {symbol}
      {amount}
    </span>;
};
export const Button = ({
  children,
  className = '',
  fullWidth = false
}: {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}) => <a href="https://pediatriayneo.com/cart/add?id=45485185106091&quantity=1" onClick={() => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'AddToCart', {
      content_name: 'Guía Cómo Ayudar a Tu Hijo con la Constipación',
      content_type: 'product',
      value: 18999,
      currency: 'ARS'
    });
  }
}} className={`inline-flex items-center justify-center bg-brand-coral hover:bg-[#d45442] text-white font-nunito font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(232,97,77,0.39)] hover:shadow-[0_6px_20px_rgba(232,97,77,0.23)] hover:-translate-y-1 transition-all duration-200 ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`} data-id="element-337">
    {children}
  </a>;
export const AlertBar = () => <div className="fixed top-0 left-0 right-0 z-50 bg-brand-coral text-white text-center py-2.5 px-4 font-inter font-semibold text-xs sm:text-sm shadow-md" data-id="element-338">
    ⚠️ OFERTA DE LANZAMIENTO — Precio especial + 4 Bonos GRATIS solo por tiempo
    limitado
  </div>;